export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '162ad60e-f7c7-43b6-ac04-2efd4cebf98a';
export const MODAL_CLOSE_SEC = 2.5;
